import React, { useState } from 'react';
import { Bell, Mail, Save, AlertTriangle, Clock } from 'lucide-react';
export function SupplierSettings() {
  const [settings, setSettings] = useState({
    notificationEnabled: true,
    emailNotifications: true,
    thresholds: {
      warning: 30,
      urgent: 14,
      critical: 1,
      nonCompliant: 7
    },
    complianceEmail: 'compliance@company.com'
  });
  const handleSave = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real app, this would save to backend
    alert('Settings saved successfully!');
  };
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-2">
      <main className="max-w-3xl mx-auto px-6 py-8" data-id="element-3">
        <div className="mb-6" data-id="element-4">
          <h1 className="text-2xl font-semibold text-gray-900" data-id="element-5">
            Compliance Settings
          </h1>
          <p className="text-gray-600" data-id="element-6">
            Configure supplier compliance notifications and thresholds
          </p>
        </div>
        <form onSubmit={handleSave} data-id="element-7">
          {/* Notification Settings */}
          <div className="bg-white rounded-lg border p-6 mb-6" data-id="element-8">
            <h2 className="text-lg font-medium text-gray-900 mb-4 flex items-center gap-2" data-id="element-9">
              <Bell className="w-5 h-5 text-purple-600" data-id="element-10" />
              Notification Settings
            </h2>
            <div className="space-y-4" data-id="element-11">
              <div className="flex items-center justify-between" data-id="element-12">
                <div data-id="element-13">
                  <p className="font-medium text-gray-700" data-id="element-14">
                    Enable Notifications
                  </p>
                  <p className="text-sm text-gray-500" data-id="element-15">
                    Receive alerts about supplier compliance status
                  </p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer" data-id="element-16">
                  <input type="checkbox" checked={settings.notificationEnabled} onChange={e => setSettings({
                  ...settings,
                  notificationEnabled: e.target.checked
                })} className="sr-only peer" data-id="element-17" />
                  <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-purple-600" data-id="element-18"></div>
                </label>
              </div>
              <div className="flex items-center justify-between" data-id="element-19">
                <div data-id="element-20">
                  <p className="font-medium text-gray-700" data-id="element-21">
                    Email Notifications
                  </p>
                  <p className="text-sm text-gray-500" data-id="element-22">
                    Send email alerts to compliance team
                  </p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer" data-id="element-23">
                  <input type="checkbox" checked={settings.emailNotifications} onChange={e => setSettings({
                  ...settings,
                  emailNotifications: e.target.checked
                })} className="sr-only peer" data-id="element-24" />
                  <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-purple-600" data-id="element-25"></div>
                </label>
              </div>
            </div>
          </div>
          {/* Threshold Settings */}
          <div className="bg-white rounded-lg border p-6 mb-6" data-id="element-26">
            <h2 className="text-lg font-medium text-gray-900 mb-4 flex items-center gap-2" data-id="element-27">
              <Clock className="w-5 h-5 text-purple-600" data-id="element-28" />
              Notification Thresholds
            </h2>
            <div className="space-y-4" data-id="element-29">
              <div data-id="element-30">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-31">
                  Warning Notification (days before expiry)
                </label>
                <input type="number" value={settings.thresholds.warning} onChange={e => setSettings({
                ...settings,
                thresholds: {
                  ...settings.thresholds,
                  warning: parseInt(e.target.value)
                }
              })} className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500" data-id="element-32" />
              </div>
              <div data-id="element-33">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-34">
                  Urgent Notification (days before expiry)
                </label>
                <input type="number" value={settings.thresholds.urgent} onChange={e => setSettings({
                ...settings,
                thresholds: {
                  ...settings.thresholds,
                  urgent: parseInt(e.target.value)
                }
              })} className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500" data-id="element-35" />
              </div>
              <div data-id="element-36">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-37">
                  Critical Notification (days before expiry)
                </label>
                <input type="number" value={settings.thresholds.critical} onChange={e => setSettings({
                ...settings,
                thresholds: {
                  ...settings.thresholds,
                  critical: parseInt(e.target.value)
                }
              })} className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500" data-id="element-38" />
              </div>
              <div data-id="element-39">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-40">
                  Non-Compliant After (days past expiry)
                </label>
                <input type="number" value={settings.thresholds.nonCompliant} onChange={e => setSettings({
                ...settings,
                thresholds: {
                  ...settings.thresholds,
                  nonCompliant: parseInt(e.target.value)
                }
              })} className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500" data-id="element-41" />
              </div>
            </div>
          </div>
          {/* Email Settings */}
          <div className="bg-white rounded-lg border p-6 mb-6" data-id="element-42">
            <h2 className="text-lg font-medium text-gray-900 mb-4 flex items-center gap-2" data-id="element-43">
              <Mail className="w-5 h-5 text-purple-600" data-id="element-44" />
              Compliance Team Email
            </h2>
            <div data-id="element-45">
              <input type="email" value={settings.complianceEmail} onChange={e => setSettings({
              ...settings,
              complianceEmail: e.target.value
            })} placeholder="compliance@company.com" className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500" data-id="element-46" />
            </div>
          </div>
          {/* Save Button */}
          <button type="submit" className="w-full flex items-center justify-center gap-2 bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition-colors" data-id="element-47">
            <Save className="w-4 h-4" data-id="element-48" />
            Save Settings
          </button>
        </form>
      </main>
    </div>;
}